import { computed, inject, provide, type ComputedRef } from 'vue'
import { bondV2Data, type BondV2Data } from './bondV2Data'

export type { BondV2Data } from './bondV2Data'

const BondV2DataKey = Symbol('BondV2Data')
const fallbackBondV2Data = computed(() => bondV2Data)

export const provideBondV2Data = (data: ComputedRef<BondV2Data>) => {
    provide(BondV2DataKey, data)
}

export const useBondV2Data = () => {
    return inject<ComputedRef<BondV2Data>>(BondV2DataKey, fallbackBondV2Data)
}
